module.exports = " <div class=vux-toast> <div class=weui_mask_transparent v-show=show></div> <div class=weui_toast :style=\"{width: width}\" :class=toastClass v-show=show :transition=transition> <i class=weui_icon_toast v-show=\"type !== 'text'\"></i> <p class=weui_toast_content v-if=text v-html=text></p> <p class=weui_toast_content v-else><slot></slot></p> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/toast/index.vue
// module id = 259
// module chunks = 2